import React from 'react';


export function SkaffoldIcon({color}) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" ><path fill={color?color:"#22b8dd"} d="M6.602 20.097H24v3.836H6.602zm-2.766-6.692h13.562v3.837H0V6.714h3.836zm13.562-9.502H0V.067h17.398zm2.766 6.692H6.602V6.758H24v10.528h-3.836z"></path></svg>);
}